import { render, staticRenderFns } from "./bonus-smmary.vue?vue&type=template&id=5f80df5a&scoped=true&"
import script from "./bonus-smmary.vue?vue&type=script&lang=js&"
export * from "./bonus-smmary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f80df5a",
  null
  
)

export default component.exports